/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomDefinitionsListRequest {
    getFixupPrototypeFunction() { return AppSecopsSbomDefinitionsListRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomDefinitionsListRequest>): AppSecopsSbomDefinitionsListRequest {
        let obj = Object.assign(new AppSecopsSbomDefinitionsListRequest(), model);
        AppSecopsSbomDefinitionsListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomDefinitionsListRequest>): AppSecopsSbomDefinitionsListRequest {
        if (!model) return null;
        return AppSecopsSbomDefinitionsListRequest.newInstance(<AppSecopsSbomDefinitionsListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomDefinitionsListRequest) {
        if (!obj) return;

        models.AppSecopsSbomDefinitionsListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomDefinitionsListRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomDefinitionsListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AppSecopsSbomDefinitionsFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AppSecopsSbomDefinitionsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AppSecopsSbomDefinitionsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AppSecopsSbomDefinitionsFilter;

}
